// ComingSoon.js
import React from 'react';
import './styles/comingSoon.css'; // optional styling

function ComingSoon() {
  return (
    <div className="coming-soon-container">
      <h1>Coming Soon</h1>
      <p>We’re working hard to finish the website. Stay tuned!</p>
    </div>
  );
}

export default ComingSoon;
